import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import '../../assets/css/home.css';

// == 关键：使用 import 引入图片（打包后路径自动处理） ==
import img1 from '../../assets/image/优势1.png';
import img2 from '../../assets/image/优势二.png';
import img3 from '../../assets/image/优势三.png';
import img4 from '../../assets/image/优势四.png';

const HomePart3: React.FC = () => {
    const themeColor = '#ac9455';
    const navigate = useNavigate();

    const [lang, setLang] = useState<'zh' | 'en'>('zh');

    useEffect(() => {
        const languageCode = localStorage.getItem('siteLanguage') || 'zh';
        setLang(languageCode === 'en' ? 'en' : 'zh');
    }, []);

    /** 文案 */
    const text = {
        zh: {
            title: "奈尔简介",
            desc: (
                <>
                    上海奈尔律师事务所以满足客户全生命周期<br />
                    的法律需求为目标，汇集了全球化网格分支<br />
                    协同、数据驱动法律服务平台、多元化律师<br />
                    团队。
                </>
            ),
            more: "了解更多",
            items: [
                { text: "国际一流服务能力", bg: img1 },
                { text: "首发律师获客智能AI", bg: img2 },
                { text: "多元化专业化律师团队", bg: img3 },
                { text: "规模化发展的践行者", bg: img4 }
            ]
        },
        en: {
            title: "About Nair",
            desc: (
                <>
                    Shanghai Nair Law Firm aims to meet<br />
                    the full life-cycle legal needs of clients.<br />
                    We bring together a global branch grid,<br />
                    data-driven legal service platform, and<br />
                    a diverse team of professional lawyers.
                </>
            ),
            more: "Learn More",
            items: [
                { text: "World-class Service Capability", bg: img1 },
                { text: "AI-Powered Lawyer Acquisition", bg: img2 },
                { text: "Diverse & Professional Lawyer Team", bg: img3 },
                { text: "Pioneer in Scaled Development", bg: img4 }
            ]
        }
    };

    const t = text[lang];

    return (
        <div className="home-part3">
            {/* 左半部分 */}
            <div className='home-part3_left'>
                <div className='home-part3_left_top'>{t.title}</div>
                <div className='home-part3_left_middle'>{t.desc}</div>

                <div className='home-part3_left_button'>
                    <Button
                        type="primary"
                        style={{ backgroundColor: themeColor }}
                        onClick={() => navigate('/home', { state: { initialView: 'service-index' } })}
                    >
                        {t.more}
                    </Button>
                </div>
            </div>

            {/* 右半部分 */}
            <div className='home-part3_left'>
                {t.items.map((item, index) => (
                    <div
                        key={index}
                        className='home-part3_left_item'
                        style={{
                            backgroundImage: `url(${item.bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    >
                        {item.text}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HomePart3;
